import React, { useState, useEffect } from "react";
import Header from "../../common/Header/Header";
import Sidebar from "../../common/Sidebar/Sidebar";
import action from "../../asessts/Images/arrow_left.svg";
import TrackIcon from "../../asessts/Images/track_right_icon.svg";
import { useParams } from "react-router-dom";
import Api from "../../services/Api";
import StarRatings from "react-star-ratings";
import Loading from "../../common/Loading/Loading";
import { formatOrderStatus } from "../../utils/paymentFailureNotifications";

function CompleteDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState([]);
  const [reviews, setReviews] = useState({});
  const [failedOrder, setFailedOrder] = useState({});
  const [feedback, setFeedback] = useState("");
  const [reason, setReason] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [allPhotos, setAllPhotos] = useState([]);

  const OrderDetails = async () => {
    try {
      setIsLoading(true);
      const response = await Api.get_complete_order(id);
      const trackOrderListing =
        response?.data?.response?.trackOrderListing || [];
      setOrderDetails(response?.data?.response?.trackOrderListing || []);
      setReviews(response?.data?.response?.reviews);
      const lastItem = trackOrderListing[trackOrderListing.length - 1];
      const status = lastItem?.status;
      setOrderStatus(response?.data?.response?.status);
      // if (response?.data?.response?.status === "failed") {
      setFailedOrder(response?.data?.response?.FailedOrderDetails);
      // }

      switch (status) {
        case "accepted-by-lender":
          setAllPhotos(
            lastItem?.acceptedReturnedDressDetails?.receivedDressPhotos || []
          );
          break;
        case "refund-by-admin":
          const disputeByLenderDetail = trackOrderListing.find(
            (item) => item.status === "dispute-by-lender"
          )?.disputeByLenderDetail;
          const disputeByBorrowerDetail = trackOrderListing.find(
            (item) => item.status === "dispute-by-borrower"
          )?.disputeByBorrowerDetail;
          setFeedback(lastItem?.refundByAdminDetails?.reasonOfRefund);

          // if (disputeByLenderDetail) {
          //   setAllPhotos(disputeByLenderDetail.disputedPhotos);
          // } else if (disputeByBorrowerDetail) {
          //   setAllPhotos(disputeByBorrowerDetail.disputedPhotos);
          // }
          break;
        case "request-rejected":
          setReason(lastItem?.rejectedDetail?.reason);
          break;
        default:
          setAllPhotos([]);
          break;
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching video details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    OrderDetails();
  }, [id]);
  const isPaymentFailedOrder =
    orderStatus === "payment failed" ||
    orderStatus === "failed" ||
    failedOrder?.status === "payment failed";

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    return date.toLocaleDateString("en-US", options);
  };

  const formatStatus = formatOrderStatus;

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header imageUrl={action} title={`Order details`} />
        <div className="loaction-list-main order-list-main">
          {isLoading ? (
            <Loading />
          ) : (
            <div className="order-tracking-main">
              <div className="tracking-left">
                <div className="head">
                  <h3>Order Tracking Details</h3>
                </div>
                <div className="details">
                  {allPhotos.length > 0 && (
                    <div className="order-photos">
                      <label htmlFor="">Product Dispatched Photos</label>
                      <div className="img">
                        {allPhotos.map((photo, index) => (
                          <img
                            style={{
                              width: "200px",
                              height: "200px",
                              objectFit: "cover",
                            }}
                            className="py-3"
                            key={index}
                            src={photo}
                            alt={`order ${index}`}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="input-group">
                    {failedOrder?.orderId && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Order ID</label>
                        <input
                          type="text"
                          value={failedOrder?.orderId}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.txId && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Transaction ID</label>
                        <input
                          type="text"
                          value={failedOrder?.txId}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.reason && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Reason</label>
                        <input
                          type="text"
                          value={failedOrder?.reason}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.reasonOfDispute && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Reason Of Dispute</label>
                        <input
                          type="text"
                          value={failedOrder?.reasonOfDispute}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.reasonOfIssueResolved && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Reason Of Issue Resolved</label>
                        <input
                          type="text"
                          value={failedOrder?.reasonOfIssueResolved}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.reasonOfReject && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Reason Of Reject</label>
                        <input
                          type="text"
                          value={failedOrder?.reasonOfReject}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.reasonOfRefund && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Reason Of Refund</label>
                        <input
                          type="text"
                          value={failedOrder?.reasonOfRefund}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.lenderName && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Lender Name</label>
                        <input
                          type="text"
                          value={failedOrder?.lenderName}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.lenderEmail && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Lender Email</label>
                        <input
                          type="text"
                          value={failedOrder?.lenderEmail}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.borrowerName && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Borrower Name</label>
                        <input
                          type="text"
                          value={failedOrder?.borrowerName}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                    {failedOrder?.borrowerEmail && (
                      <div class="input-field" style={{ width: "48%" }}>
                        <label for="">Borrower Email</label>
                        <input
                          type="text"
                          value={failedOrder?.borrowerEmail}
                          placeholder={"#542365"}
                        />
                      </div>
                    )}
                  </div>

                  <div className="feedback">
                    {reviews?.lender?.comments && (
                      <div style={{ width: "100%" }}>
                        <p>Lender's Feedback</p>
                        <StarRatings
                          rating={reviews?.lender?.ratings}
                          starRatedColor="gold"
                          starDimension="20px"
                          starSpacing="2px"
                        />
                        <div class="input-field">
                          <textarea
                            value={reviews?.lender?.comments}
                          ></textarea>
                        </div>
                      </div>
                    )}
                    {reviews?.borrower?.comments && (
                      <div style={{ width: "100%" }}>
                        <p>Borrower's Feedback</p>
                        <StarRatings
                          rating={reviews?.borrower?.ratings}
                          starRatedColor="gold"
                          starDimension="20px"
                          starSpacing="2px"
                        />
                        <div class="input-field">
                          <textarea
                            value={reviews?.borrower?.comments}
                          ></textarea>
                        </div>
                      </div>
                    )}
                    {feedback && (
                      <div style={{ width: "100%" }}>
                        <p>Admin's Feedback</p>
                        <div class="input-field">
                          <textarea value={feedback}></textarea>
                        </div>
                      </div>
                    )}
                    {reason && (
                      <div style={{ width: "100%" }}>
                        <p>Rejected Reason</p>
                        <div class="input-field">
                          <textarea value={reason}></textarea>
                        </div>
                      </div>
                    )}
                  </div>
                  {isPaymentFailedOrder && (
                    <div class="input-group failed-order">
                      <div className="payment-failed-banner">
                        Payment Failed – Cancelled
                      </div>
                      <div class="input-field">
                        <label for="">Order ID</label>
                        <input
                          type="text"
                          value={failedOrder?.orderId}
                          placeholder={""}
                          readOnly
                        />
                      </div>

                      {failedOrder?.txId && (
                        <div class="input-field">
                          <label for="">Stripe Payment Intent</label>
                          <input
                            type="text"
                            value={failedOrder?.txId}
                            placeholder="#542365"
                            readOnly
                          />
                        </div>
                      )}
                      <div class="input-field">
                        <label for="">Borrower Name</label>
                        <input
                          type="text"
                          value={failedOrder?.borrowerName}
                          placeholder="#542365"
                          readOnly
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Borrower Email</label>
                        <input
                          type="text"
                          value={failedOrder?.borrowerEmail}
                          placeholder="#542365"
                          readOnly
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Lender Name</label>
                        <input
                          type="text"
                          value={failedOrder?.lenderName}
                          placeholder="#542365"
                          readOnly
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Lender Email</label>
                        <input
                          type="text"
                          value={failedOrder?.lenderEmail}
                          placeholder="#542365"
                          readOnly
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Reason (Stripe)</label>
                        <textarea
                          value={failedOrder?.reason}
                          placeholder="#542365"
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                  {orderStatus === "failed" && !isPaymentFailedOrder && (
                    <div class="input-group failed-order">
                      <div class="input-field">
                        <label for="">Order ID</label>
                        <input
                          type="text"
                          value={failedOrder?.orderId}
                          placeholder={""}
                        />
                      </div>

                      {failedOrder?.txId && (
                        <div class="input-field">
                          <label for="">Transaction Id</label>
                          <input
                            type="text"
                            value={failedOrder?.txId}
                            placeholder="#542365"
                          />
                        </div>
                      )}
                      <div class="input-field">
                        <label for="">Borrower Name</label>
                        <input
                          type="text"
                          value={failedOrder?.borrowerName}
                          placeholder="#542365"
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Borrower Email</label>
                        <input
                          type="text"
                          value={failedOrder?.borrowerEmail}
                          placeholder="#542365"
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Lender Name</label>
                        <input
                          type="text"
                          value={failedOrder?.lenderName}
                          placeholder="#542365"
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Lender Email</label>
                        <input
                          type="text"
                          value={failedOrder?.lenderEmail}
                          placeholder="#542365"
                        />
                      </div>
                      <div class="input-field">
                        <label for="">Reason (Stripe)</label>
                        <textarea
                          type="text"
                          value={failedOrder?.reason}
                          placeholder="#542365"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {Array.isArray(orderDetails) && orderDetails.length > 0 && (
                <div className="tracking-right">
                  <h3>Order Tracking Details</h3>
                  <div className="return-back">
                    <div className="head">
                      <h4>
                        {isPaymentFailedOrder
                          ? "Payment Failed – Cancelled"
                          : reason
                          ? "Request Rejected"
                          : "Order Completed"}
                      </h4>
                    </div>
                    <div className="track-path">
                      <div className="order-track-path">
                        {orderDetails.map((order, index) => (
                          <div className="key-chain" key={index}>
                            <div className="key-chain-img">
                              <span>
                                <img src={TrackIcon} alt="" />
                              </span>
                            </div>
                            <div className="key-chain-head">
                              <h3>{formatStatus(order.status)}</h3>
                              <p>{formatDate(order.createdAt)}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CompleteDetail;
